import { useEffect, useState } from "react";
import { Buildings } from "@phosphor-icons/react";
import { Reveal, Stagger, StaggerItem } from "./motion";
import { api } from "../lib/api";

export default function ClientLogos() {
  const [clients, setClients] = useState([]);
  useEffect(() => { api.get("/clients").then((r) => setClients(r.data)).catch(() => {}); }, []);

  if (!clients.length) return null;

  return (
    <section data-testid="client-logos" className="bg-white border-b border-ez-text">
      <div className="max-w-[1600px] mx-auto px-5 md:px-8 py-20 md:py-28">
        <Reveal>
          <div className="flex items-center gap-3 font-mono-ez text-xs uppercase tracking-[0.3em] text-ez-text/50 mb-6">
            <span className="w-8 h-px bg-ez-text/30" /> Our Customers
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl uppercase tracking-tighter max-w-4xl leading-[0.95]">
            The companies that trust us to run their operations
          </h2>
          <p className="mt-6 max-w-2xl text-ez-text/70 leading-relaxed">
            From FMCG and food &amp; frozen to temperature-controlled and consumer-product
            supply chains — these are the teams we execute for, day in and day out.
          </p>
          <div className="mt-4 font-mono-ez text-xs uppercase tracking-widest text-ez-text/40">
            {clients.length} {clients.length === 1 ? "customer" : "customers"} &amp; counting
          </div>
        </Reveal>

        <Stagger className="mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 border-t border-l border-ez-text">
          {clients.map((c) => {
            const inner = c.logo_url ? (
              <img
                src={c.logo_url}
                alt={c.name}
                className="max-h-16 max-w-[80%] object-contain grayscale group-hover:grayscale-0 transition-all duration-500"
              />
            ) : (
              <div className="flex flex-col items-center gap-3 text-ez-text/60 group-hover:text-ez-text transition-colors">
                <Buildings size={28} weight="duotone" className="text-ez-yellow" />
                <span className="font-display text-lg uppercase tracking-tight text-center break-words leading-tight">{c.name}</span>
              </div>
            );
            return (
              <StaggerItem key={c.id} className="border-b border-r border-ez-border">
                <div className="group h-40 md:h-44 flex items-center justify-center p-8 hover:bg-ez-bg transition-colors">
                  {c.website ? (
                    <a href={c.website} target="_blank" rel="noreferrer" title={c.name} className="flex items-center justify-center w-full h-full">
                      {inner}
                    </a>
                  ) : inner}
                </div>
              </StaggerItem>
            );
          })}
        </Stagger>
      </div>
    </section>
  );
}
